import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
// import data from './data.json';

import Header from './header';
import AboutUsComponent from './Aboutus';
import ContactusComponent from './Contactus';
import Carousel from './carousel';
import Condition from './condition';
import Footer from './footer';

import '@fontsource/roboto/500.css';

function Contactus({home=true,aboutus=true,contactus=false}) {
  return (
    <>
      <title>Contact Us  </title>
      <meta name="description" content="Contact Us Labour Chowk Team." />
      <meta name="keywords" content="Labour Chowk Contact Us Labour Chowk Team." />
      <meta name="author" content="Labour Chowk Contact Us Labour Chowk Team."></meta>      
      <Header data={[home,aboutus,contactus]}></Header>
      <ContactusComponent></ContactusComponent>
      <Footer data={[home,aboutus,contactus]}> </Footer>        
    </>
  )
}

function Aboutus({home=true,aboutus=false,contactus=true}) {
  return (
    <>
      <title>About Us  </title>
      <meta name="description" content="Labour Chowk Online platform founder." />
      <meta name="keywords" content="Labour Chowk Online platform founder Sandeep Patil Shweta Dekate Sachin Katiyar Raju Gupta ." />
      <meta name="author" content="Labour Chowk Online Platform Founder."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <AboutUsComponent></AboutUsComponent>
      <Footer data={[home,aboutus,contactus]}> </Footer>        
    </>
  )
}

function Home({home=false,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Labour Chowk Online Delhi NCR </title>
      <meta name="description" content="Labour Chowk Online is a platform for connecting laborers with job opportunities. Companies can post job listings, and laborers can apply for or get jobs directly through the platform.We provide Services into both Domestic & Commerical location on demand." />
      <meta name="keywords" content="worker near me,labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, daily wages labour near me , painter near me, at Delhi NCR, at Noida , at Greater Noida, at Ghaziabad, at Faridabad, at Gurugram, at Ballia, at Luckhnow, at Patna, at Bihar, at delhi" />
      <meta name="author" content="Labour Chowk Online Team."></meta>      
      <Header data={[home,aboutus,contactus]}></Header>
      <Carousel></Carousel>
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>        
    </>
  )
}

function UttarPradeshNoidaNoidaExtensionLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Uttar Pradesh Noida Extension Labour Helper</title>
      <meta name="description" content="Verified Labour Helper in Uttar Pradesh Noida Noida Extension." />
      <meta name="keywords" content="worker near me,labour near me, construction labour near me, Helper near me, Raj mistri near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, daily wages labour near me , painter near me, at Delhi NCR, at Noida, at Greater Noida,at Noida Extension, at Sector 16,at sector 18, at Botanical Garden, at New Ashok Nagar, at Gaur City Noida, at Char Murti noida extension." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <div class="align-center">
          <h1>Uttar Pradesh Noida Noida Extension Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
          <p>Looking for a reliable labour helper in Uttar Pradesh Noida Noida Extension? Our verified labour helpers are available to assist you with various tasks. Whether you need help with construction, moving, or general labor work, our skilled helpers are here to provide efficient and trustworthy services. Contact us today to find the best labour helper near you in Noida Extension, including areas like Sector 16, 18, Botanical Garden, New Ashok Nagar, Gaur City.</p>
      </div>
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>
    </>
  )  
}

function UttarPradeshGreaterNoidaLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Uttar Pradesh Greater Noida Labour Helper</title>
      <meta name="description" content="Verified labour helpers in Greater Noida, Uttar Pradesh — reliable daily-wage workers for construction, painting, and moving." />
      <meta name="keywords" content="Labour Helper Manson Tiles Mistri Heavy Painter Labour Painter near me, Greater Noida, Knowledge Park, Gaurtulyam, Migsun Noida Greater Noida Expressway, daily wage labour, construction helper" />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <div class="align-center">
        <h1>Greater Noida Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Find trusted and verified labour helpers in Greater Noida for construction, painting, shifting, and general labour work. Fast booking and verified profiles across sectors like Knowledge Park and surrounding neighborhoods.</p>
      </div>
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>
    </>
  );
}

function UttarPradeshGhaziabadLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Uttar Pradesh Ghaziabad Labour Helper</title>
      <meta name="description" content="Verified labour helpers in Ghaziabad, Uttar Pradesh — hire skilled helpers for construction, masonry, painting and moving." />
      <meta name="keywords" content="worker near me,labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, daily wages labour near me , painter near me, at Delhi NCR, at Noida , at Ghaziabad, at Vaishali, at Indirapuram, at Raj Nagar." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <div class="align-center">
        <h1>Ghaziabad Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Local, verified labour helpers in Ghaziabad ready for construction, masonry, painting and shifting tasks. Search helpers by locality like Vaishali, Indirapuram and Raj Nagar.</p>
      </div>
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>
    </>
  );
}

function UttarPradeshLucknowLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Uttar Pradesh Lucknow Labour Helper Heavy Labour</title>
      <meta name="description" content="Verified labour helpers in Lucknow, Uttar Pradesh — hire skilled helpers for construction, masonry, painting and moving shifting, loading unloading." />
      <meta name="keywords" content="Labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, at Lucknow, daily wages labour near me , painter near me, at UP, at Uttar Pradesh, at Kanpur." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <div class="align-center">
        <h1>Lucknow Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Local, verified labour helpers in Lucknow ready for construction, masonry, painting and shifting tasks. Get helpers by skills.</p>
      </div>
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>
    </>
  );
}



function HaryanaFaridabadLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Haryana Faridabad Labour Helper</title>
      <meta name="description" content="Verified labour helpers in Faridabad — hire reliable daily-wage workers for heavy labour, painting, and general construction." />
      <meta name="keywords" content="Labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, at Faridabad, daily wages labour near me , painter near me, at Haryana." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>
      <div class="align-center">
        <h1>Faridabad Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Experienced and verified labour helpers in Faridabad for heavy labour, painting, and general construction work. Quick bookings and local availability across Ballabgarh and nearby areas.</p>
      </div>

      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer>
    </>
  );
}

function HaryanaGurugramLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>Haryana Gurugram Labour Helper</title>
      <meta name="description" content="Verified labour helpers in Gurugram — dependable workers for construction, renovation, painting and shifting services." />
      <meta name="keywords" content="worker near me,labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, daily wages labour near me , painter near me, at Delhi NCR, at Gurugram, at Gurgaon, at Sector 14, at Cyber City, at sohna road, near ifco chowk, near railway station." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      <Header data={[home,aboutus,contactus]}></Header>    
      <div class="align-center">
        <h1>Gurugram Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Find reliable labour helpers in Gurugram for construction, renovation, and painting jobs. Verified profiles and services across residential and commercial sectors including Cyber City.</p>
      </div>

      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer> 
    </>
  );
}

function NewDelhiDwarkaLabourHelper({home=true,aboutus=true,contactus=true}) {
  return (
    <>
      <title>New Delhi Dwarka Labour Helper</title>
      <meta name="description" content="Verified labour helpers in Dwarka, New Delhi — hire reliable daily-wage workers for construction, moving and painting." />
      <meta name="keywords" content="worker near me,labour near me, construction labour near me, Helper near me, Manson near me, Tiles near me, Mistri near me, Heavy Labour near me, Painter near me, house keeping staff near me, security guard near me, loading unloading labour near me, labour supplier, labour contractor near me,labour on rent, skilled workers, unskilled workers near me, daily wages labour near me , painter near me, at Delhi NCR, at Dwarka, at New Delhi, at Sector 10, at Sector 22, at Nangloi, at Rohini, at SOuth Ex, loading unloading near me, construction helper near me, painter near me." />
      <meta name="author" content="Labour Chowk Online Team."></meta>
      
      <Header data={[home,aboutus,contactus]}></Header>
      <div id="Target-Section" class="align-center">
        <h1>Dwarka Best Labour Helper Manson Tiles Mistri Heavy Labour Painter</h1>
        <p>Trusted and verified labour helpers in Dwarka for moving, construction, and painting tasks. Service available across Dwarka sectors with quick local response.</p>    
      </div>

      
      <Condition></Condition>
      <Footer data={[home,aboutus,contactus]}> </Footer> 
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      {/* Navigation */}
      {/* <Header /> */}
      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Aboutus" element={<Aboutus />} />
        <Route path="/Contactus" element={<Contactus />} />
        
        <Route
          path="/Uttar-Pradesh-Noida-Noida-Extension-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<UttarPradeshNoidaNoidaExtensionLabourHelper />}
        />
        <Route
          path="/Uttar-Pradesh-Greater-Noida-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<UttarPradeshGreaterNoidaLabourHelper />}
        />
        <Route
          path="/Uttar-Pradesh-Ghaziabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<UttarPradeshGhaziabadLabourHelper />}
        />
        <Route
          path="/Uttar-Pradesh-Lucknow-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<UttarPradeshLucknowLabourHelper />}
        />        
        <Route
          path="/Haryana-Faridabad-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<HaryanaFaridabadLabourHelper />}
        />
        <Route
          path="/Haryana-Gurugram-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<HaryanaGurugramLabourHelper />}
        />
        <Route
          path="/New-Delhi-Dwarka-Labour-Helper-Manson-Tiles-Mistri-Heavy-Labour-Painter"
          element={<NewDelhiDwarkaLabourHelper />}
        />        
      </Routes>
    </BrowserRouter>
  );
}

export default App;

